import { useEffect, useRef } from "react";
import { authService } from "../../services/api";
import { GOOGLE_CLIENT_ID } from "../../config/GoogleConfig";
import "./BotonGoogle.css";

const _configurado =
  GOOGLE_CLIENT_ID && !GOOGLE_CLIENT_ID.startsWith("PEGA_AQUI");

function cargarScriptGoogle() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.accounts && window.google.accounts.id) {
      resolve();
      return;
    }
    const _existente = document.getElementById("google-gsi-script");
    if (_existente) {
      _existente.addEventListener("load", resolve);
      _existente.addEventListener("error", reject);
      return;
    }
    const _script = document.createElement("script");
    _script.src = "https://accounts.google.com/gsi/client";
    _script.id = "google-gsi-script";
    _script.async = true;
    _script.defer = true;
    _script.onload = resolve;
    _script.onerror = reject;
    document.head.appendChild(_script);
  });
}

function BotonGoogle({ onExito, onError, texto = "signin_with" }) {
  const _contenedor = useRef(null);

  useEffect(() => {
    if (!_configurado) return;

    let _cancelado = false;

    const manejarCredencial = async (respuesta) => {
      try {
        const _res = await authService.loginGoogle(respuesta.credential);
        localStorage.setItem("token", _res.data.token);
        localStorage.setItem("nombre", _res.data.nombre);
        localStorage.setItem("email", _res.data.email);
        localStorage.setItem("esAdmin", _res.data.esAdmin);
        if (onExito) onExito(_res.data);
      } catch (error) {
        if (onError) onError(error);
      }
    };

    cargarScriptGoogle()
      .then(() => {
        if (_cancelado || !_contenedor.current) return;
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: manejarCredencial,
        });
        window.google.accounts.id.renderButton(_contenedor.current, {
          theme: "outline",
          size: "large",
          shape: "pill",
          text: texto,
          width: 280,
          locale: "es",
        });
      })
      .catch(() => {
        if (onError) onError(new Error("No se pudo cargar Google"));
      });

    return () => {
      _cancelado = true;
    };
  }, [onExito, onError, texto]);

  if (!_configurado) {
    return (
      <button
        type="button"
        className="google-btn-fallback"
        onClick={() =>
          alert(
            "El login con Google todavía no está configurado. Falta pegar el Client ID en GoogleConfig.js y en el backend."
          )
        }
      >
        <span className="google-btn-icono">G</span>
        Entrar con Google
      </button>
    );
  }

  return <div className="google-btn-contenedor" ref={_contenedor}></div>;
}

export default BotonGoogle;
